import { Config } from "../../Config";
import { Laya } from "../../Laya";
import { Render2DProcessor } from "../display/Render2DProcessor";
import { Blit2DCMD } from "../display/Scene2DSpecial/RenderCMD2D/Blit2DCMD";
import { LayaGL } from "../layagl/LayaGL";
import { Vector4 } from "../maths/Vector4";
import { FilterMode } from "../RenderEngine/RenderEnum/FilterMode";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { Shader3D } from "../RenderEngine/RenderShader/Shader3D";
import { RenderTexture } from "../resource/RenderTexture";
import { Texture2D } from "../resource/Texture2D";
import { TextureArrayRegistry2D } from "../webgl/utils/TextureArrayRegistry2D";
import { TextureMergeShaderInit } from "./shader/TextureMergeShaderInit";
export class LargeTex extends RenderTexture {
    constructor(width, height, format = RenderTargetFormat.R8G8B8A8, depthStencilFormat = null, mipmap = false, limitMipmap = -1, sRGB = true, gammaCorrection = 1.0) {
        super(width, height, format, depthStencilFormat, mipmap, 1, false, sRGB);
        this._limitMipmap = -1;
        this._willDestroyTex = [];
        this.immediately = false;
        this.commands = new Set();
        this._waitMergeIds = new Set();
        this._limitMipmap = limitMipmap;
        this.anisoLevel = 1;
        if (this._limitMipmap >= 0) {
            if (this.mipmapCount > this._limitMipmap)
                this._setMaxMipmapLevel(this._limitMipmap);
        }
        this._shader = Shader3D.find("TexMerge");
        if (Config.useTextureArray) {
            const alloc = TextureArrayRegistry2D.allocateLayerAsTexture(width, height, TextureFormat.R8G8B8A8, 64, sRGB);
            const tc = LayaGL.textureContext;
            if (alloc && tc) {
                this._disposeResource();
                const internalArrayTex = alloc.array._texture;
                this._renderTarget = tc.createRenderTargetFromArrayLayer(internalArrayTex, alloc.layer, format, depthStencilFormat, sRGB);
                this._texture = this._renderTarget._textures[0];
                TextureArrayRegistry2D.register(this, alloc.array, alloc.layer);
            }
        }
        this._texture.gammaCorrection = gammaCorrection;
    }
    onUpdate(force = false) {
        if (!this.cmdBuffer || !this.commands.size)
            return null;
        let values = this.commands.values();
        let cmd = values.next().value;
        let ids = [];
        let cacheInvertY = Render2DProcessor.rendercontext2D.invertY;
        while (cmd && (force || Laya.stage.getTimeFromFrameStart() < 30)) {
            this.cmdBuffer.addCacheCommand(cmd);
            this.cmdBuffer.applyOne(true);
            this.commands.delete(cmd);
            this._waitMergeIds.delete(cmd.source.id);
            ids.push(cmd.source.id);
            cmd = values.next().value;
        }
        Render2DProcessor.rendercontext2D.invertY = cacheInvertY;
        this.commands.size || this._doDestoryTex();
        return ids;
    }
    hasWaitMerge(id) {
        return this._waitMergeIds.has(id);
    }
    _setMaxMipmapLevel(count) {
        this.baseMipmapLevel = 0;
        this.maxMipmapLevel = count;
    }
    addTexture(x, y, w, h, expand, smallTex, needRemove) {
        let cmd = null;
        if (expand > 0)
            cmd = this._drawTex(x, y, w, h, expand, smallTex);
        cmd = this._drawTex(x, y, w, h, 0, smallTex);
        if (needRemove)
            this._willDestroyTex.push(smallTex);
        return cmd;
    }
    addColor(x, y, w, h, color, format) {
        let cf;
        let smallTex;
        if (format == TextureFormat.R8G8B8) {
            const r = color.x * 255;
            const g = color.y * 255;
            const b = color.z * 255;
            cf = new Uint8Array(w * h * 3);
            for (let i = 0; i < h; i++) {
                for (let j = 0; j < w; j++) {
                    let index = i * w * 3 + j * 3;
                    cf[index] = r;
                    cf[index + 1] = g;
                    cf[index + 2] = b;
                }
            }
        }
        else if (format == TextureFormat.R8G8B8A8) {
            const r = color.x * 255;
            const g = color.y * 255;
            const b = color.z * 255;
            const a = color.w * 255;
            cf = new Uint8Array(w * h * 4);
            for (let i = 0; i < h; i++) {
                for (let j = 0; j < w; j++) {
                    let index = i * w * 4 + j * 4;
                    cf[index] = r;
                    cf[index + 1] = g;
                    cf[index + 2] = b;
                    cf[index + 3] = a;
                }
            }
        }
        smallTex = this._createSmallTex(w, h, cf);
        let cmd = this._drawTex(x, y, w, h, 0, smallTex);
        this._willDestroyTex.push(smallTex);
        return cmd;
    }
    fillColor(color, format) {
        const x = 0, y = 0, w = 4, h = 4;
        let cf;
        let smallTex;
        if (format == TextureFormat.R8G8B8) {
            const r = color.x * 255;
            const g = color.y * 255;
            const b = color.z * 255;
            cf = new Uint8Array(w * h * 3);
            for (let i = 0; i < h; i++) {
                for (let j = 0; j < w; j++) {
                    let index = i * w * 3 + j * 3;
                    cf[index] = r;
                    cf[index + 1] = g;
                    cf[index + 2] = b;
                }
            }
        }
        else if (format == TextureFormat.R8G8B8A8) {
            const r = color.x * 255;
            const g = color.y * 255;
            const b = color.z * 255;
            const a = color.w * 255;
            cf = new Uint8Array(w * h * 4);
            for (let i = 0; i < h; i++) {
                for (let j = 0; j < w; j++) {
                    const index = i * w * 4 + j * 4;
                    cf[index] = r;
                    cf[index + 1] = g;
                    cf[index + 2] = b;
                    cf[index + 3] = a;
                }
            }
        }
        smallTex = this._createSmallTex(w, h, cf);
        this._drawTex(x, y, this.width, this.height, 0, smallTex);
        this._willDestroyTex.push(smallTex);
    }
    destroy() {
        super.destroy();
        this.cmdBuffer && this.cmdBuffer.clear();
        this.cmdBuffer = null;
        this._doDestoryTex();
        this._willDestroyTex = null;
    }
    _createSmallTex(w, h, pixelArray) {
        const smallTex = new Texture2D(w, h, this.format, false, false, false);
        smallTex.setPixelsData(pixelArray, false, false);
        smallTex.filterMode = FilterMode.Point;
        return smallTex;
    }
    _doDestoryTex() {
        if (this._willDestroyTex)
            while (this._willDestroyTex.length)
                this._willDestroyTex.pop().destroy();
    }
    _drawTex(x, y, w, h, expand, smallTex) {
        const width = this.width;
        const height = this.height;
        const offsetScale = new Vector4();
        offsetScale.x = Math.max(0, x - expand) / width;
        offsetScale.y = Math.max(0, height - y - h - expand) / height;
        offsetScale.z = (w + expand * 2) / width;
        offsetScale.w = (h + expand * 2) / height;
        let sd = TextureMergeShaderInit._sdNotChange;
        if (this.gammaSpace) {
            if (smallTex.gammaSpace) {
                sd = TextureMergeShaderInit._sdNotChange;
            }
            else {
                sd = TextureMergeShaderInit._sdLinearToGamma;
            }
        }
        else {
            if (smallTex.gammaSpace) {
                sd = TextureMergeShaderInit._sdGammaToLinear;
            }
            else {
                sd = TextureMergeShaderInit._sdNotChange;
            }
        }
        let cmd = Blit2DCMD.create(smallTex, this, offsetScale, this._shader, sd, false);
        this.commands.add(cmd);
        if (this.immediately) {
            this.onUpdate(true);
        }
        else {
            this._waitMergeIds.add(smallTex.id);
        }
        return cmd;
    }
}
